const messages = {
    en: {
        emailAddress: "E-mail address",
        forgotpassword: "Forgot password?",
        username: "Username",
        clearValues: "Clear",
        send: "Send",
        pleaseEnter: "Please enter email address and/or username",
        andor: "and/or",
        verifyaddress: "Password reset link will be sent to the email address/username specified. Usually it takes up to 3 minutes for system to send email. Just click link in email body and fill password reset form. Please note that link is valid for 24 hours",
        enterTextInBlue: "Enter text in blue below",

    },
    ru: {
        emailAddress: "Адрес электронной почты",
        forgotpassword: "Забыл пароль?",
        username: "Имя пользователя",
        clearValues: "Oчистить",
        send: "Отправить",
        pleaseEnter: "Пожалуйста, введите адрес электронной почты и/или имя пользователя",
        andor: "и/или",
        verifyaddress: "Ссылка для сброса пароля будет отправлена ​​на указанный адрес электронной почты/имя пользователя. Обычно система отправляет электронное письмо в течение 3 минут. Пожалуйста, примите во внимание что ссылка действительна в течение 24 часов.",
        enterTextInBlue: "Введите текст, выделенный синим цветом",
    }
  };

  export default messages;